import Text from "shared/ui/typography/Text";
import { REACT_APP_GERS_API_URL } from "shared/config";
import Button, { ButtonTypes } from "shared/ui/button";
import Icon, { IconTypes } from "shared/ui/icon";
import { concatClassnames } from "shared/utils/concatClassnames";
import { CategoryStandardProduct } from "shared/api/middleware-api-client";
import { useEffect, useState } from "react";

const ROW_LENGTH = 6;

interface Props {
  className?: string;

  selectedSamples: CategoryStandardProduct[];
  setSelectedSamples: (sample: CategoryStandardProduct[]) => void;
}
const SelectedSamples = ({
  selectedSamples,
  setSelectedSamples,
  className,
}: Props) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useEffect(() => {
    if (isDropdownOpen && selectedSamples.length === 0)
      setIsDropdownOpen(false);
  }, [selectedSamples]);

  const onRemoveClick = (sample: CategoryStandardProduct) => {
    setSelectedSamples(selectedSamples.filter((s) => s.id !== sample.id));
  };

  return (
    <div className={concatClassnames("gg-relative", className)}>
      <Button
        type={ButtonTypes.UNSTYLED}
        className={concatClassnames(
          "gg-items-center gg-border gg-border-dark-blue-200 gg-py-3 gg-text-xs gg-font-bold gg-transition-all gg-duration-200 sm:gg-gap-x-2.5",
          isDropdownOpen ? "gg-bg-white sm:gg-bg-dark-blue" : "gg-bg-white",
          "gg-flex gg-w-full gg-justify-between sm:gg-w-fit",
        )}
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
      >
        <Text
          className={concatClassnames(
            "gg-text-uppercase gg-tracking-widest",
            isDropdownOpen
              ? "gg-text-dark-blue-800 sm:gg-text-grey-500"
              : "gg-text-dark-blue-800",
          )}
        >
          MIJN SELECTIE
        </Text>
        <Text
          className={concatClassnames(
            "gg-block gg-flex gg-h-5 gg-w-5 gg-items-center gg-justify-center gg-rounded-full gg-text-[10px]",
            selectedSamples.length === 0 && "gg-invisible",
            isDropdownOpen
              ? "gg-bg-dark-blue-700 gg-text-white sm:gg-bg-white sm:gg-text-dark-blue"
              : "gg-bg-dark-blue-700 gg-text-white",
          )}
        >
          {selectedSamples.length || 0}
        </Text>
      </Button>

      <ul
        className={concatClassnames(
          "gg-absolute gg-bottom-full gg-left-0 gg-right-0 gg-z-50 gg-w-full gg-gap-2.5 gg-border gg-border-b-0 gg-border-dark-blue-200 gg-bg-white gg-p-3.5 gg-shadow-main gg-transition-all sm:gg-bottom-[unset] sm:gg-left-[unset] sm:gg-right-14 sm:gg-top-10 sm:gg-w-max sm:gg-border-b",
          isDropdownOpen ? "gg-grid gg-grid-cols-6" : "gg-hidden",
        )}
      >
        <span className="gg-absolute -gg-top-2 gg-right-5 gg-hidden gg-h-0 gg-w-0 gg-border-b-8 gg-border-l-8 gg-border-r-8 gg-border-b-white gg-border-l-transparent gg-border-r-transparent sm:gg-block"></span>
        {selectedSamples.map((sample, i) => (
          <li key={`selected-sample-${i}`} className="gg-text-center">
            {sample.thumbnailId.length !== 0 ? (
              <img
                className="gg-mb-2 gg-h-11 gg-w-11 gg-rounded gg-border gg-border-dark-blue gg-bg-contain gg-shadow-main gg-transition-all sm:gg-h-14 sm:gg-w-14"
                src={`${REACT_APP_GERS_API_URL}/StandardProducts/download-file/${sample.thumbnailId}`}
                alt={sample.mainImageAltText}
              />
            ) : (
              <div className="gg-mb-2 gg-h-11 gg-w-11 gg-rounded gg-border gg-border-dark-blue sm:gg-h-14 sm:gg-w-14"></div>
            )}

            <button onClick={() => onRemoveClick(sample)}>
              <Icon name={IconTypes.REMOVE}></Icon>
            </button>
          </li>
        ))}
        {(selectedSamples.length === 0 ||
          selectedSamples.length % ROW_LENGTH > 0) &&
          Array(ROW_LENGTH - (selectedSamples.length % ROW_LENGTH))
            .fill(0)
            .map((_, i) => (
              <div
                key={`selected-sampe-placeholder-${i}`}
                className="gg-mb-2 gg-h-11 gg-w-11 gg-rounded gg-border gg-border-dashed gg-border-dark-blue-500 sm:gg-h-14 sm:gg-w-14"
              ></div>
            ))}
      </ul>
    </div>
  );
};
export default SelectedSamples;
